import { FormDatePicker, FormInput, FormSelect } from "@/components";
import useFilter from "./useFilter";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import {
  ASSIGN_TO,
  NAME,
  PRIORITY,
  ROLE,
  SCHOOL,
  START_DATE,
  TASK_STATUS,
} from "../consts";
import { X } from "lucide-react";
import { FC } from "react";
import { FilterProps } from "./types";
import { PRIORITY_TYPES, roles } from "../consts";
import { taskStatus } from "@/lib/utils";
import { useGetSchoolsQuery } from "@/services";
import useEmployeesQuery from "@/services/employeeManagement/useEmployeeManagementMutation";

const Filter: FC<FilterProps> = ({
  onCancel,
  filterData,
  setFilterData,
  onApply,
}) => {
  const { form, onSubmit, requiredFields, isMobile, onClear } = useFilter({
    filterData,
    setFilterData,
    onCancel,
    onApply,
  });
  const { errors } = form.formState;

  const priorityOptions = Object.values(PRIORITY_TYPES).map((p) => ({
          label: p.charAt(0).toUpperCase() + p.slice(1).toLowerCase(), 
          value: p, 
    }));
  
  const statusOptions = Object.values(taskStatus).map((s) => ({
    label: s.label,
    value: s.value,
  }));

  const { data: schoolRes, isLoading: isLoadingSchool } = useGetSchoolsQuery({});
  
    const schoolOptions =
      schoolRes?.data?.[0]?.records?.map((item: any) => ({
        label: item.schoolName,
        value: item.schoolId,
      })) || [];


  const roleOptions = Object.values(roles).map((r) => ({
    label: r.label,
    value: r.value,
  }));

  const { data: emp_res, isLoading: isLoadingTerms } = useEmployeesQuery({});
  
    const assignTooptions =
      emp_res?.data?.[0]?.records?.map((item: any) => ({
        label: item.name,
        value: item.profile_id,
      })) || [];

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">Filter</DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="relative">
            <div className="bg-white rounded-lg py-[25px] max-h-[70vh] lg:max-h-[95vh] overflow-y-auto pb-[130px] px-1">
              <div className="grid grid-cols-1 gap-[25px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Task Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                />
                <FormSelect
                  name={PRIORITY}
                  control={form.control}
                  label="Priority"
                  placeholder="Please select"
                  error={errors[PRIORITY]?.message}
                  isRequired={requiredFields.includes(PRIORITY)}
                  options={priorityOptions}
                />
                <FormDatePicker
                  name={START_DATE}
                  control={form.control}
                  label="Start Date"
                  placeholder="Please select"
                  error={errors[START_DATE]?.message}
                  isRequired={requiredFields.includes(START_DATE)}
                />
                <FormSelect
                  name={TASK_STATUS}
                  control={form.control}
                  label="Task Status"
                  placeholder="Please select"
                  error={errors[TASK_STATUS]?.message}
                  isRequired={requiredFields.includes(TASK_STATUS)}
                  options={statusOptions}
                />
                {/* <FormSelect
                  name={SCHOOL}
                  control={form.control}
                  label="School"
                  placeholder="Please select"
                  error={errors[SCHOOL]?.message}
                  isRequired={requiredFields.includes(SCHOOL)}
                  options={schoolOptions}
                /> */}
                <FormSelect
                  name={ROLE}
                  control={form.control}
                  label="Role"
                  placeholder="Please select"
                  error={errors[ROLE]?.message}
                  isRequired={requiredFields.includes(ROLE)}
                  options={roleOptions}
                />
                <FormSelect
                  name={ASSIGN_TO}
                  control={form.control}
                  label="Assign To"
                  placeholder="Please select"
                  error={errors[ASSIGN_TO]?.message}
                  isRequired={requiredFields.includes(ASSIGN_TO)}
                  options={assignTooptions}
                />
              </div>
            </div>
            <div className="flex flex-col gap-3 absolute bottom-3 w-full bg-white pb-[25px] z-[3]">
              <div className="flex justify-end">
                <Button
                  variant="ghost"
                  type="button"
                  className="text-red-600"
                  onClick={onClear}
                >
                  Clear All
                </Button>
              </div>
              <Button type="submit">Apply Filter</Button>
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default Filter;
